import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const css = `
.dim-panel {
    display: flex;
    flex-direction: column;
    gap: 2px;
    background: rgba(15, 28, 58, 0.92);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 16px 14px;
    min-width: 220px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.4);
    user-select: none;
}

.dim-panel__title {
    font-size: 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.35);
    margin-bottom: 10px;
    padding-left: 4px;
}

.dim-panel__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 8px;
    border-radius: 10px;
    transition: background 0.15s;
    gap: 8px;
}

.dim-panel__row:hover {
    background: rgba(255,255,255,0.05);
}

.dim-panel__label {
    font-size: 11px;
    color: rgba(255,255,255,0.6);
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dim-panel__control {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
}

.dim-panel__btn {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.8);
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s, transform 0.1s;
    padding: 0;
    line-height: 1;
    flex-shrink: 0;
}

.dim-panel__btn:hover {
    background: rgba(255,255,255,0.18);
}

.dim-panel__btn:active {
    transform: scale(0.88);
    background: rgba(255,255,255,0.28);
}

.dim-panel__input {
    width: 52px;
    height: 24px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(255,255,255,0.07);
    color: #fff;
    font-size: 12px;
    padding: 0 4px;
    box-sizing: border-box;
    -moz-appearance: textfield;
    outline: none;
    transition: border-color 0.15s, background 0.15s;
}

.dim-panel__input:focus {
    border-color: rgba(255,255,255,0.4);
    background: rgba(255,255,255,0.12);
}

.dim-panel__input::-webkit-inner-spin-button,
.dim-panel__input::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

.dim-panel__divider {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 6px 0;
}

.dim-panel__save {
    margin-top: 10px;
    width: 100%;
    height: 38px;
    border-radius: 10px;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.15s;
}

.dim-panel__save:hover {
    background: rgba(255,255,255,0.2);
}

.dim-panel__save:active {
    background: rgba(255,255,255,0.08);
}

.dim-panel__group-label {
    font-size: 9px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.2);
    padding: 4px 8px 2px;
    margin-top: 4px;
}
`;
// Разбить controls на группы по разделителю
// Первые N без "Вынос" — основные размеры, остальные — крыша
function groupControls(controls) {
    const main = [];
    const roof = [];
    for (const c of controls) {
        if (c.label.toLowerCase().includes('вынос') || c.label.toLowerCase().includes('крыш')) {
            roof.push(c);
        }
        else {
            main.push(c);
        }
    }
    return { main, roof };
}
function ControlRow({ control }) {
    return (_jsxs("div", { className: "dim-panel__row", children: [_jsx("span", { className: "dim-panel__label", children: control.label }), _jsxs("div", { className: "dim-panel__control", children: [_jsx("button", { className: "dim-panel__btn", onClick: () => control.onChange(+(control.value - control.step).toFixed(4)), children: "\u2212" }), _jsx("input", { className: "dim-panel__input", type: "number", value: control.value, onChange: e => control.onChange(Number(e.currentTarget.value)) }), _jsx("button", { className: "dim-panel__btn", onClick: () => control.onChange(+(control.value + control.step).toFixed(4)), children: "+" })] })] }));
}
export function DimensionPanel({ controls, onSave, title, btnText }) {
    const { main, roof } = groupControls(controls);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsxs("div", { className: "dim-panel", children: [_jsx("div", { className: "dim-panel__title", children: title }), main.map((c, i) => _jsx(ControlRow, { control: c }, i)), roof.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: "dim-panel__divider" }), roof.map((c, i) => _jsx(ControlRow, { control: c }, i))] })), onSave && (_jsx("button", { className: "dim-panel__save", onClick: onSave, children: btnText }))] })] }));
}
